import React from 'react';
import { Card, CardBody, Container } from 'reactstrap';
import { PageNames } from 'shared/constants/appConstants';
import PageHeader from 'shared/components/PageHeader';
import CommitmentTypeUtilizationPage from './components/CommitmentTypeUtilizationPage';

const RiUtilizationPage = (props) => (
  <Container>
    <PageHeader title={PageNames.RI_UTILIZATION} showDate />
    <Card>
      <CardBody style={{ minHeight: '300px' }}>
        <CommitmentTypeUtilizationPage {...props} commitmentType="ri" />
      </CardBody>
    </Card>
  </Container>
);

export default RiUtilizationPage;
